import React from 'react';

const PrintHeader = () => {
  return (
    <>
      {/* Start - nav */}
      <div className="form-inline my-2 my-lg-0 bg-light" id="removeLayoutHeader">
        <div className="">
          <a className="navbar-brand" href="#">
            <img src="/assets/images/logo-ar-black.png" alt="" className="nav-img" />
          </a>
        </div>
        <div className="site-name" id="sitename">
          <h4 style={{textAlign: 'center'}}>
            مبادرة السيد رئيس الجمهورية لفحص المقبلين على الزواج
          </h4>
        </div>

        <div className="col-md-2">
          <img style={{width: '100%'}} src="/assets/images/100Million.png" id="100million" alt="100 مليون صحة" />
        </div>
        <div className="col-md-2">
          <img style={{width: '100%'}} src="/assets/images/OncLogo.png" id="Oncology" alt="مبادرة الكشف المبكر وعلاج الأورام السرطانية" />
        </div>
      </div>
      <nav className="navbar navbar-expand-lg navbar-light custom-bg-info">
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
      </nav>
      {/* End - nav */}
    </>
  );
};

export default PrintHeader;
